import React from 'react'
import { useFormik } from 'formik'
import {
    OverContainer,
    SectionContact,
    SectionInformation,
    SectionInformationSection,
    ContentFormik,
    ContentImput,
    ContentButton,
    FormSection,
    ContentFinishFooter,
    ContentIconSocial,
    SectionInformationOver,
    ContentData,
    SectionContactLimit,
    ContentSubscribe,
    ContentSubscribeTitle,
} from './styles'
import { SocialLabels, FooterLabels } from 'src/constants'
import { MapInformation } from './MapInformation'
import { LineHeight15White } from 'src/components/common/Typography/typography'
import { subscribe } from 'src/api/authOtp'
import { FiltForm } from 'src/components/common/Form'
import { MapSocial } from './MapSocial'
import { Props, SubscribeProps } from './types'
import { useTranslations } from 'src/provider/LocaleProvider'
import { useValidationSchema } from './validations'

export function Footer({ setCompleteSubscription }: SubscribeProps) {
    const t = useTranslations()
    const { Social } = SocialLabels()
    const { FooterInformation } = FooterLabels()
    const ValidationSchema = useValidationSchema()
    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: ValidationSchema,
        onSubmit: (values, { resetForm }) =>
            handleSubmitForm({ values, resetForm }),
    })
    async function handleSubmitForm({ values, resetForm }: Props) {
        try {
            const resp = await subscribe(values)
            if (resp.status === 201) {
                setCompleteSubscription(true)
                resetForm()
            }
        } catch (e) {
            console.error(e)
        }
    }
    return (
        <OverContainer paddingTop={'xxmedium'}>
            <SectionContact>
                <SectionContactLimit
                    paddingTop={['medium', 'medium', 0, 0]}
                    paddingLeft={['medium', 'medium', 'xxmedium', 0]}
                >
                    <ContentSubscribeTitle>
                        <LineHeight15White
                            variant={'h2'}
                            fontSize={'xxxsmall'}
                            fontWeight={400}
                        >
                            {t('subscription.content')}
                        </LineHeight15White>
                    </ContentSubscribeTitle>
                    <ContentSubscribe
                        paddingTop={'xxxmedium'}
                        paddingBottom={'xxxmedium'}
                    >
                        <LineHeight15White
                            variant={'h2'}
                            fontSize={'xxxsmall'}
                            fontWeight={600}
                        >
                            {t('subscription.title')}
                        </LineHeight15White>

                        <FormSection onSubmit={formik.handleSubmit}>
                            <ContentFormik>
                                <ContentImput>
                                    <ContentData>
                                        <FiltForm
                                            id={'email'}
                                            title={t(
                                                'fields.email.labelCompany'
                                            )}
                                            errors={formik.errors.email}
                                            touched={formik.touched.email}
                                            value={formik.values.email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                    </ContentData>
                                    <ContentButton type="submit">
                                        {t('subscription.title')}
                                    </ContentButton>
                                </ContentImput>
                            </ContentFormik>
                        </FormSection>
                    </ContentSubscribe>
                </SectionContactLimit>
            </SectionContact>

            <SectionInformationOver>
                <SectionInformation
                    paddingTop={'xxsmall'}
                    paddingBottom={'xxsmall'}
                >
                    <SectionInformationSection>
                        {FooterInformation.map((information) => {
                            return (
                                <MapInformation
                                    key={information.id}
                                    {...information}
                                />
                            )
                        })}
                    </SectionInformationSection>
                </SectionInformation>
            </SectionInformationOver>
            <ContentFinishFooter paddingTop={'xxmedium'}>
                <ContentIconSocial>
                    {Social.map((social) => {
                        return <MapSocial key={social.id} {...social} />
                    })}
                </ContentIconSocial>
                <ContentIconSocial paddingTop={'medium'}>
                    ©2022, All right reserved.
                </ContentIconSocial>
            </ContentFinishFooter>
        </OverContainer>
    )
}
